import { DateRange, LocalizedText } from '@common/models';
import { DatesService } from '@common/services/dates.service';

import { AlertApi } from '../../api/models';
import { DateTime } from 'luxon';

export class Alert
{
    title: LocalizedText;
    text: LocalizedText;
    rangeActivation: DateRange;
    periodIsValid: boolean;

    get textFr () {
        return this.text['fr-FR'];
    }

    get textEn () {
        return this.text['en-US'];
    }

    get since () {
        return this.rangeActivation.since;
    }

    get until () {
        return this.rangeActivation.until;
    }

    constructor (public id: string, public active: boolean)
    {
    }

    public static mapperFromApi (source: AlertApi): Alert
    {
        const target = new Alert(source.id, source.active);

        const since = DateTime.fromISO(source.rangeActivation.since!, { setZone: true });
        const until = DateTime.fromISO(source.rangeActivation.until!, { setZone: true });
        target.rangeActivation = new DateRange(since, until);

        target.title = source.title;
        target.text = source.text;

        return target;
    }
}
